module.exports = Object(typeof globalThis !== 'undefined' ? globalThis
  : typeof global !== 'undefined' ? global
  : typeof self !== 'undefined' ? self
  : this || {})["prettier"];